import React, { useState } from 'react';
import { useAuth } from '../teacher/AuthContext'; // Adjust path
import { useNavigate } from 'react-router-dom';

const CompleteProfile = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phoneNumber: '',
    role: 'learner' // Default role
  });

  // Safety check: prevent "Cannot destructure property 'currentUser' of undefined"
  if (!auth) {
    return <div className="flex justify-center items-center h-screen">Loading Auth...</div>;
  }

  const { currentUser, updateProfileData } = auth;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Assuming updateProfileData is a function in your AuthContext 
      // that saves additional fields to Firestore/Database
      await updateProfileData(formData);
      navigate('/pendingapproval');
    } catch (error) {
      console.error("Failed to update profile", error);
      alert("Update failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          Complete Your Profile
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Logged in as <span className="font-medium text-blue-600">{currentUser?.email}</span>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Personal Name Blocks */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
  <div>
    <label className="block text-sm font-medium text-gray-700">First Name</label>
    <input
      required
      type="text"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
      value={formData.first_name || ''}
      onChange={(e) => setFormData({...formData, first_name: e.target.value})}
    />
  </div>

  <div>
    <label className="block text-sm font-medium text-gray-700">Last Name</label>
    <input
      required
      type="text"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
      value={formData.last_name || ''}
      onChange={(e) => setFormData({...formData, last_name: e.target.value})}
    />
  </div>
</div>

            <div>
              <label className="block text-sm font-medium text-gray-700">I am a...</label>
              <select 
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                value={formData.role}
                onChange={(e) => setFormData({...formData, role: e.target.value})}
              >
                <option value="learner">Learner</option>
                <option value="tutor">Tutor</option>
              </select>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none disabled:opacity-50"
              >
                {loading ? 'Saving...' : 'Finish Registration'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfile;